import "core-js/modules/es.object.get-own-property-descriptor";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class;

import { lock } from '@/util/decorator';
import { getPlatform } from '@/util/helper';
import { request } from './util'; // 魔方链接

var baseUrl = '//vip.video.qq.com/gift/fcgi-bin/comm_cgi';
var _window$setting$$ = window.setting.道具配置.cid,
    cid = _window$setting$$ === void 0 ? 'mzc002002kw24da' : _window$setting$$;
var PropsService = (_class = /*#__PURE__*/function () {
  function PropsService() {
    _classCallCheck(this, PropsService);
  }

  _createClass(PropsService, null, [{
    key: "getMyProps",
    value: function getMyProps() {
      var options = {
        name: 'query_my_gift_list',
        cid: cid
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "giveProps",
    value: function giveProps(data) {
      var options = _objectSpread({
        name: 'gift_buy_use',
        cid: cid,
        platform: getPlatform(),
        giftID: window.setting.道具配置.道具id
      }, data);

      return request()(baseUrl, options);
    }
  }, {
    key: "getStarRanks",
    value: function getStarRanks() {
      var options = {
        name: 'gift_rank_stars',
        rankType: 1001,
        cid: cid
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "getFansRanks",
    value: function getFansRanks(id) {
      var options = {
        name: 'gift_rank_fans',
        rankType: 2001,
        cid: cid,
        topCount: 5
      };

      if (id) {
        options.recipientType = 4;
        options.recipientID = id;
      } else {
        options.flag = 3;
      }

      return request()(baseUrl, options);
    }
  }, {
    key: "getMyVoteInfo",
    value: function getMyVoteInfo(params) {
      var options = _objectSpread({
        name: 'gift_rank_voted_star',
        rankType: 3001,
        cid: cid
      }, params);

      return request()(baseUrl, options);
    }
  }]);

  return PropsService;
}(), (_applyDecoratedDescriptor(_class, "getMyProps", [lock], Object.getOwnPropertyDescriptor(_class, "getMyProps"), _class), _applyDecoratedDescriptor(_class, "giveProps", [lock], Object.getOwnPropertyDescriptor(_class, "giveProps"), _class), _applyDecoratedDescriptor(_class, "getStarRanks", [lock], Object.getOwnPropertyDescriptor(_class, "getStarRanks"), _class)), _class);
export default PropsService;